export interface MenuChildItem {
    name: string;
    permission: string | string[];
    permissionType?: string;
    link: string;
    param?: any;
    tag?: any;
}

export interface MenuChildGroup {
    caption: string;
    tag?: any;
    items: MenuChildItem[];
}

export interface MenuItem {
    name: string;
    caption: string;
    permission: string | string[];
    permissionType?: string;
    link: string;
    groups: MenuChildGroup[];
}

export const MENU: MenuItem[] = [
    // {
    //     name: 'test',
    //     caption: 'Test',
    //     permission: ['EdiPortalUser'],
    //     link: 'test',
    //     groups: [{
    //         caption: 'Test',
    //         items: [{
    //             name: 'Test',
    //             permission: ['EdiPortalUser'],
    //             link: 'test',
    //         },
    //         {
    //             name: '-',
    //             permission: ['EdiPortalUser'],
    //             link: '',
    //         },
    //         {
    //             name: 'Test 2',
    //             permission: ['EdiPortalUser'],
    //             link: 'test/t2',
    //         }]
    //     }]
    // },
    {
        name: 'monitor',
        caption: 'Monitor',
        permission: ['Monitor_View_Status', 'Monitor_View_Groups', 'Monitor_View_Items', 'Monitor_View_Schedules'],
        link: 'monitor',
        groups: [
            {
                caption: 'Monitor',
                items: [
                    {
                        name: 'Monitor status',
                        permission: 'Monitor_View_Status',
                        link: 'monitor',
                    },
                    {
                        name: '-',
                        permission: ['Monitor_View_Groups', 'Monitor_View_Items', 'Monitor_View_Schedules'],
                        link: '',
                    },
                    {
                        name: 'Monitor groups',
                        permission: 'Monitor_View_Groups',
                        link: 'monitor/groups',
                    },
                    {
                        name: 'Monitor items',
                        permission: 'Monitor_View_Items',
                        link: 'monitor/items',
                    },
                    {
                        name: 'Monitor schedules',
                        permission: 'Monitor_View_Schedules',
                        link: 'monitor/schedules',
                    }
                ]
            }
        ]
    },
    {
       name: 'alert',
       caption: 'Alerts',
       permission: ['Alert_View_Status'],
       link: 'alert/status',
       groups: [
           {
               caption: 'Alerts',
               items: [
                   {
                       name: 'Alert status',
                       permission: 'Alert_View_Status',
                       link: 'alert/status',
                   },
                   {
                       name: 'Alert default email template',
                       permission: 'Mail_View_Templates',
                       link: 'settings/mail-templates/details',
                       param: { mailTemplateKey: 'AlertDefault' }
                   }
               ]
           }
       ]
    },
    {
        name: 'tracking',
        caption: 'Tracking',
        permission: ['Tracking_View_Search', 'TrackingStatusEvent_View_Search', 'Tracking_Action_UploadDocument', 'TrackingstatusEvent_View_Search', 'Tracking_View_Search_Views', 'Tracking_View_ActiveRetries'],
        link: 'tracking',
        groups: [
            {
                caption: 'Tracking',
                items: [
                    {
                        name: 'Search Documents/Interchanges',
                        permission: 'Tracking_View_Search',
                        link: 'tracking',
                    },
                    {
                        name: 'Search Status Events',
                        permission: 'TrackingStatusEvent_View_Search',
                        link: 'tracking/searchstatusevents',
                    },
                    {
                        name: 'Upload document',
                        permission: 'Tracking_Action_UploadDocument',
                        link: '',
                        tag: { uploadDocument: true }
                    },
                    {
                        name: 'Tracking Search Views',
                        permission: ['Tracking_View_Search','Tracking_View_Search_Views'],
                        permissionType: 'And',
                        link: 'tracking/views'
                    },
                    {
                        name: 'Cancelled Message Status',
                        permission: 'Tracking_View_CancelMessageStatus',
                        link: 'tracking/cancelmessagestatus'
                    },
                    {
                        name: 'Active Retries',
                        permission: 'Tracking_View_ActiveRetries',
                        link: 'tracking/active-retries',
                    },
                ]
            }
        ]
    },
    {
        name: 'partners',
        caption: 'Partners',
        permission: ['Partner_View_Search', 'Partner_Action_GeneralShow'],
        permissionType: 'And',
        link: 'partner',
        groups: [
            {
                caption: 'Partners',
                items: [
                    {
                        name: 'Search',
                        permission: 'Partner_View_Search',
                        link: 'partner',
                    },
                    {
                        name: 'Onboard New Partner',
                        permission: ['Partner_View_PartnerDetails', 'Partner_Action_PartnerCreate'],
                        permissionType: 'And',
                        link: 'partner/details',
                        param: { createNewOnboarding: true, force: 1 }
                    },
                    {
                        name: 'Create new',
                        permission: ['Partner_View_PartnerDetails', 'Partner_Action_PartnerCreate'],
                        permissionType: 'And',
                        link: 'partner/details',
                        param: { createNew: true, force: 1 }
                    },
                    {
                        name: 'Import',
                        permission: 'Partner_Action_PartnerImport',
                        link: 'partner/import',
                    },
                    {
                        name: '-',
                        permission: ['Partner_Action_GeneralShow', 'Partner_View_Search', 'Partner_View_Systems'],
                        link: '',
                    },
                    {
                        name: 'Tags',
                        permission: ['Partner_View_Tags','Partner_Action_GeneralShow'],
                        permissionType: 'And',
                        link: 'partner/tags',
                    },
                    {
                        name: 'Contact Types',
                        permission: 'Partner_View_Search',
                        link: 'partner/contacttypes',
                    },
                    {
                        name: 'Partner Systems',
                        permission: 'Partner_View_Systems',
                        link: 'partner/system',
                    }
                ]
            }
        ]
    },
    {
        name: 'distributions',
        caption: 'Distributions',
        permission: 'Distribution_View_Search',
        link: 'distribution',
        groups: [
            {
                caption: 'Distributions',
                items: [
                    {
                        name: 'Search',
                        permission: 'Distribution_View_Search',
                        link: 'distribution',
                    },
                    {
                        name: 'Create new',
                        permission: ['Distribution_View_DistributionDetails', 'Distribution_Action_DistributionCreate'],
                        permissionType: 'And',
                        link: 'distribution/result/details',
                        param: { createNew: true, force: 1 }
                    },
                    {
                        name: 'Create new Fallback',
                        permission: ['Distribution_View_DistributionDetails', 'Distribution_Action_FallbackDistributionCreate'],
                        permissionType: 'And',
                        link: 'distribution/result/details',
                        param: { createNew: true, fallback: true, force: 1 }
                    },
                    {
                        name: 'Import',
                        permission: ['Distribution_Action_DistributionImport'],
                        link: 'distribution/import',
                    }
                ]
            }
            // {
            //     caption: 'Agreements',
            //     items: [
            //         {
            //             name: 'AS4 agreements',
            //             permission: 'Distribution_View_Agreement',
            //             link: 'distribution/agreements'
            //         }
            //     ]
            // }
        ]
    },
    {
        name: 'transport',
        caption: 'Transport',
        permission: ['Transport_View_IncomingLocations_List', 'Transport_View_OutgoingLocation_List', 'Developer_View', 'Transport_Action_OutgoingLocation_Import'],
        link: 'transport-locations',
        groups: [
            {
                caption: 'Transport',
                items: [
                    {
                        name: 'Incoming locations',
                        permission: 'Transport_View_IncomingLocations_List',
                        link: 'transport-locations/incoming',
                    },
                    {
                        name: 'Outgoing locations',
                        permission: 'Transport_View_OutgoingLocation_List',
                        link: 'transport-locations/outgoing',
                    },
                    {
                        name: 'Http handlers',
                        permission: 'Developer_View',
                        link: 'transport-locations/http-handlers',
                    },
                    {
                        name: 'Advanced http handlers',
                        permission: 'Developer_View',
                        link: 'transport-locations/advanced-http-handlers',
                    },
                    {
                        name: 'Import',
                        permission: 'Transport_Action_OutgoingLocation_Import',
                        link: 'transport-locations/import',
                    },
                ]
            }
        ]
    },
    {
        name: 'mcp',
        caption: 'MCP (preview)',
        permission: 'McpServer_View',
        link: 'mcp/mcp-servers',
        groups: []
    },
    {
        name: 'reports',
        caption: 'Reports',
        permission: 'Reports_View_ReportOverview',
        link: 'reports',
        groups: [ ]
    },
    {
        name: 'settings',
        caption: 'Settings',
        permission: '',
        link: 'myprofile',
        groups: [
            {
                caption: 'Settings',
                items: [
                    {
                        name: 'My profile',
                        permission: '',
                        link: 'myprofile',
                    },
                    {
                        name: 'Company profile',
                        permission: 'Settings_View_CompanyProfile',
                        link: 'companyprofile',
                    },
                    {
                        name: '-',
                        permission: ['Users_View_Search', 'Users_View_UserGroups', 'Users_View_DataGroups', 'Users_View_UserRoles'],
                        link: '',
                    },
                    {
                        name: 'Users',
                        permission: 'Users_View_Search',
                        link: 'user',
                    },
                    {
                        name: 'User groups',
                        permission: ['Users_View_UserGroups', 'Users_View_UserRoles'],
                        permissionType: 'And',
                        link: 'user/usergroups',
                    },
                    {
                        name: 'Data groups',
                        permission: 'Users_View_DataGroups',
                        link: 'user/datagroups',
                    },
                    {
                        name: 'Roles',
                        permission: ['Users_View_UserRoles', 'Users_View_Permissions'],
                        permissionType: 'And',
                        link: 'user/roles',
                    },
                    {
                        name: 'Azure AD',
                        permission: 'AzureAD_View',
                        link: 'azure-ad',
                    },
                    {
                        name: '-',
                        permission: ['Stakeholder_View', 'ErrorRules_View', 'Mail_View_Log', 'Mail_View_Settings'],
                        link: '',
                    },
                    {
                        name: 'Stakeholders',
                        permission: 'Stakeholder_View',
                        link: 'error/stakeholder',
                    },
                    {
                        name: 'Error rules',
                        permission: 'ErrorRules_View',
                        link: 'error/error-rules',
                    },
                    {
                        name: 'Mail settings',
                        permission: 'Mail_View_Settings',
                        link: 'settings/mail',
                    },
                    {
                        name: 'Mail templates',
                        permission: 'Mail_View_Templates',
                        link: 'settings/mail-templates',
                    },
                    {
                        name: 'Mail log',
                        permission: 'Mail_View_Log',
                        link: 'settings/mail-log',
                    },
                    {
                        name: '-',
                        permission: 'Identity_View',
                        link: '',
                    },
                    {
                        name: 'Identity clients',
                        permission: 'Identity_View',
                        link: 'identity/clients',
                    },
                    {
                        name: 'Identity tokens',
                        permission: 'Identity_View',
                        link: 'identity/tokens',
                    },
                    {
                        name: '-',
                        permission: 'Settings_View_Settings',
                        link: '',
                    },
                    {
                        name: 'Settings',
                        permission: 'Settings_View_Settings',
                        link: 'settings/settings',
                    },
                    {
                        name: '-',
                        permission: '',
                        link: '',
                    },
                    {
                        name: 'Show change log',
                        permission: 'ChangeLog_View',
                        link: 'settings/changelog',
                    },
                    {
                        name: 'Show errors',
                        permission: '',
                        link: 'generic-errors',
                    },
                    {
                        name: 'Document retention',
                        permission: 'Maintenance_View_DocumentRetentions',
                        link: 'settings/document-retention',
                    },
                    {
                        name: '-',
                        permission: 'Scheduler_View_Scheduling',
                        link: '',
                    },
                    {
                        name: 'Scheduling',
                        permission: 'Scheduler_View_Scheduling',
                        link: 'settings/scheduler',
                    },
                    {
                        name: 'Sequences',
                        permission: 'Developer_View', //CHANGE
                        link: 'settings/sequences',
                    },
                    {
                        name: 'Concurrency Keys',
                        permission: 'Developer_View', //CHANGE
                        link: 'settings/concurrencykeys',
                    },
                    {
                        name: '-',
                        permission: 'ImportExport_View_Settings',
                        link: '',
                    },
                    {
                        name: 'Import/Export settings',
                        permission: 'ImportExport_View_Settings',
                        link: 'settings/importexport',
                    },
                ]
            },
            {
                caption: 'Cache',
                items: [
                    {
                        name: 'Clear cache',
                        permission: '', //CHANGE
                        link: '',
                        tag: { clearCache: true }
                    }
                ]
            }
        ]
    },
    {
        name: 'developer',
        caption: 'Developer',
        permission: 'Developer_View',
        link: 'developer',
        groups: []
    },
    {
        name: 'test-tool',
        caption: 'Test tool',
        permission: 'TestTool_View',
        link: 'test-tool/test-cases',
        groups: [
            {
                caption: 'Test tool',
                items: [
                    {
                        name: 'Test cases',
                        permission: '',
                        link: 'test-tool/test-cases'
                    },
                    {
                        name: 'Create test case',
                        permission: 'TestTool_Action_TestCase_Create',
                        link: 'test-tool/create-test-case'
                    },
                    {
                        name: 'Test runs',
                        permission: 'TestTool_Action_TestCase_Run',
                        link: 'test-tool/test-runs'
                    },
                    {
                        name: '-',
                        permission: ['TestTool_Action_TestCase_Run', 'TestTool_Action_Compare_Rules_Import'],
                        link: '',
                    },
                    {
                        name: 'Compare rules',
                        permission: 'TestTool_Action_TestCase_Run',
                        link: 'test-tool/compare-rules'
                    },
                    {
                        name: 'Import compare rules',
                        permission: 'TestTool_Action_Compare_Rules_Import',
                        link: 'test-tool/compare-rules-import',
                    }
                ]
            }
        ]
    }
];
